/**
 * Availability Form Types
 *
 * Type definitions for the AvailabilityConfigurationModal form state
 * and related ViewModel composable.
 */
/**
 * Default form state values
 */
export const DEFAULT_FORM_STATE = {
    dateRange: { start: '', end: '' },
    days: [],
    startTime: '',
    endTime: '',
    standardMaxParticipants: 1,
    overcapacityMaxParticipants: null,
    overflowPrice: null,
    netPrice: 0,
    priceType: 'PERSON',
    commissionAmount: 0,
    commissionType: 'PERCENTAGE',
    taxRate: 0.13,
    allowReservations: true,
};
